export default "__VITE_ASSET__Ln3U_1kR__"